// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Transaction-listLayout-KhYFf {
	list-style: none;
	margin-bottom: 0;
	padding-left: 0;
}

.Transaction-currencyColor-CijHM {
	color: var(--currency-text-color);
}

.Transaction-tabItem-v5RNd {
	display: block;
	padding: 0px 0px 7px;
	position: relative;
	text-align: center;
	font-size: 18px;
	color: var(--modalText-color);
	cursor: pointer;
	border-bottom: 1px solid transparent;
	margin-right: 30px;
}

.Transaction-tabItem-v5RNd:hover {
	text-decoration: none;
	color: var(--common-text-color);
}

.Transaction-active-LokEH .Transaction-tabItem-v5RNd {
	color: var(--common-text-color);
	border-color: var(--common-link-color);
	text-decoration: none;
	font-weight: 500;
}

.Transaction-listContainer-sb8za {
	margin: 0px;
	padding: 0px;
	list-style: none;
	border-bottom: 1px solid var(--primary-border);
}

.Transaction-marginBottom-AMM5R {
	margin-bottom: 25px;
}

.Transaction-marginRight-S1Bqo {
	margin-right: 6px;
}

.Transaction-searchWidth-wjs9p {
	width: 100%;
	max-width: 310px;
	height: 48px;
}

.Transaction-filterBtn-pprXr {
	height: 48px;
	padding: 13px 24px;
	font-size: 18px;
	font-weight: 500;
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
	border-color: var(--border-secondary-color);
}

.Transaction-filterBtn-pprXr:hover,
.Transaction-filterBtn-pprXr:active,
.Transaction-filterBtn-pprXr:focus,
.Transaction-filterBtn-pprXr:active:hover {
	color: var(--btn-primary-bg);
	background-color: var(--primary-white-bg);
	border-color: var(--border-secondary-color);
	-webkit-box-shadow: unset;
	        box-shadow: unset;
}

.Transaction-plusIcon-C8aef {
	margin-right: 6px;
}

.Transaction-csvExport-lq2sF {
	border: 1px solid var(--border-secondary-color);
	border-radius: 6px;
	padding: 12px 19px;
	margin-right: 12px;
	height: 48px;
}

.Transaction-csvExportLink-dyZsL {
	font-size: 18px;
	color: var(--btn-primary-bg);
	font-weight: 500;
}

.Transaction-csvExportLink-dyZsL:hover,
.Transaction-csvExportLink-dyZsL:active,
.Transaction-csvExportLink-dyZsL:focus,
.Transaction-csvExportLink-dyZsL:active:hover {
	color: var(--btn-primary-bg);
	text-decoration: unset !important;
}

.Transaction-searchMarginRight-Vdwq7 {
	margin-right: auto;
}

.Transaction-searchBox-UCAdn {
	position: relative;
}

.Transaction-searchIcon-Qeh3d {
	position: absolute;
	top: 17px;
	left: 18px;
}

.Transaction-searchFlexBox-cGnXa {
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.Transaction-linkCssActive-UnA4I {
	background: var(--btn-primary-bg) !important;
	color: var(--primary-white-bg) !important;
	border-radius: 6px !important;
	-webkit-border-radius: 6px !important;
	-moz-border-radius: 6px !important;
	-ms-border-radius: 6px !important;
	-o-border-radius: 6px !important;
}

.Transaction-linkCssActive-UnA4I .Transaction-plusIcon-C8aef {
	filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);
	-webkit-filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);
}

.Transaction-confirmCodeColor-cSJXb {
	color: var(--common-link-color);
}

.Transaction-confirmCodeColor-cSJXb:hover,
.Transaction-confirmCodeColor-cSJXb:focus,
.Transaction-confirmCodeColor-cSJXb:active,
.Transaction-confirmCodeColor-cSJXb:active:hover,
.Transaction-confirmCodeColor-cSJXb:focus:hover {
	text-decoration: none;
	color: var(--common-link-color)
}

.Transaction-detailsWidth-BZ1ws {
	min-width: 250px;
}

.Transaction-wordBreak-Xf1zk {
	word-break: break-word !important;
}

.Transaction-noDataIconSec-AH4SE {
	width: 114px;
	height: 110px;
}

.Transaction-noTransactionSecSpace-mc1BV {
	margin-top: 76px;
	margin-bottom: 119px;
}

.Transaction-iconTop-dMpgv {
	position: relative;
	top: -2px
}

@media screen and (max-width: 767px) {
	.Transaction-mobileWidth-B9mTd {
		width: 100% !important;
	}

	.Transaction-listContainer-sb8za {
		border-bottom: unset;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		    -ms-flex-direction: column;
		        flex-direction: column;
	}

	.Transaction-listContainer-sb8za li .Transaction-tabItem-v5RNd {
		margin-right: 0;
		margin-left: 0;
		margin-bottom: 12px;
	}

	.Transaction-listFlex-KXaAx,
	.Transaction-csvExport-lq2sF {
		margin-right: 0;
		width: 100%;
		margin-bottom: 18px;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.Transaction-filterBtn-pprXr {
		width: 100%;
	}

	.Transaction-filterBtn-pprXr {
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.Transaction-detailsWidth-BZ1ws {
		min-width: 230px;
	}

	.Transaction-noTransactionSecSpace-mc1BV {
		margin-top: 50px;
		margin-bottom: 50px;
	}
}

@media (min-width: 992px) and (max-width: 1024px) {
	.Transaction-searchWidth-wjs9p {
		max-width: 240px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Transaction/Transaction.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,6BAA6B;CAC7B,eAAe;CACf,oCAAoC;CACpC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;CAC/B,sCAAsC;CACtC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,8CAA8C;AAC/C;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;AACb;;AAGA;CACC,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,4BAA4B;CAC5B,yCAAyC;CACzC,2CAA2C;AAC5C;;AAEA;;;;CAIC,4BAA4B;CAC5B,yCAAyC;CACzC,2CAA2C;CAC3C,yBAAiB;SAAjB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,+CAA+C;CAC/C,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,eAAe;CACf,4BAA4B;CAC5B,gBAAgB;AACjB;;AAEA;;;;CAIC,4BAA4B;CAC5B,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,4CAA4C;CAC5C,yCAAyC;CACzC,6BAA6B;CAC7B,qCAAqC;CACrC,kCAAkC;CAClC,iCAAiC;CACjC,gCAAgC;AACjC;;AAEA;CACC,8FAA8F;CAC9F,sGAAsG;AACvG;;AAEA;CACC,+BAA+B;AAChC;;AAEA;;;;;CAKC,qBAAqB;CACrB;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB;AACD;;AAEA;CACC;EACC,sBAAsB;CACvB;;CAEA;EACC,oBAAoB;EACpB,mBAAe;MAAf,eAAe;EACf,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;CACvB;;CAEA;EACC,eAAe;EACf,cAAc;EACd,mBAAmB;CACpB;;CAEA;;EAEC,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;EAChB,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,gBAAgB;CACjB;AACD","sourcesContent":[".listLayout {\n\tlist-style: none;\n\tmargin-bottom: 0;\n\tpadding-left: 0;\n}\n\n.currencyColor {\n\tcolor: var(--currency-text-color);\n}\n\n.tabItem {\n\tdisplay: block;\n\tpadding: 0px 0px 7px;\n\tposition: relative;\n\ttext-align: center;\n\tfont-size: 18px;\n\tcolor: var(--modalText-color);\n\tcursor: pointer;\n\tborder-bottom: 1px solid transparent;\n\tmargin-right: 30px;\n}\n\n.tabItem:hover {\n\ttext-decoration: none;\n\tcolor: var(--common-text-color);\n}\n\n.active .tabItem {\n\tcolor: var(--common-text-color);\n\tborder-color: var(--common-link-color);\n\ttext-decoration: none;\n\tfont-weight: 500;\n}\n\n.listContainer {\n\tmargin: 0px;\n\tpadding: 0px;\n\tlist-style: none;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.marginBottom {\n\tmargin-bottom: 25px;\n}\n\n.marginRight {\n\tmargin-right: 6px;\n}\n\n.searchWidth {\n\twidth: 100%;\n\tmax-width: 310px;\n\theight: 48px;\n}\n\n\n.filterBtn {\n\theight: 48px;\n\tpadding: 13px 24px;\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n\tborder-color: var(--border-secondary-color);\n}\n\n.filterBtn:hover,\n.filterBtn:active,\n.filterBtn:focus,\n.filterBtn:active:hover {\n\tcolor: var(--btn-primary-bg);\n\tbackground-color: var(--primary-white-bg);\n\tborder-color: var(--border-secondary-color);\n\tbox-shadow: unset;\n}\n\n.plusIcon {\n\tmargin-right: 6px;\n}\n\n.csvExport {\n\tborder: 1px solid var(--border-secondary-color);\n\tborder-radius: 6px;\n\tpadding: 12px 19px;\n\tmargin-right: 12px;\n\theight: 48px;\n}\n\n.csvExportLink {\n\tfont-size: 18px;\n\tcolor: var(--btn-primary-bg);\n\tfont-weight: 500;\n}\n\n.csvExportLink:hover,\n.csvExportLink:active,\n.csvExportLink:focus,\n.csvExportLink:active:hover {\n\tcolor: var(--btn-primary-bg);\n\ttext-decoration: unset !important;\n}\n\n.searchMarginRight {\n\tmargin-right: auto;\n}\n\n.searchBox {\n\tposition: relative;\n}\n\n.searchIcon {\n\tposition: absolute;\n\ttop: 17px;\n\tleft: 18px;\n}\n\n.searchFlexBox {\n\tflex-wrap: wrap;\n}\n\n.linkCssActive {\n\tbackground: var(--btn-primary-bg) !important;\n\tcolor: var(--primary-white-bg) !important;\n\tborder-radius: 6px !important;\n\t-webkit-border-radius: 6px !important;\n\t-moz-border-radius: 6px !important;\n\t-ms-border-radius: 6px !important;\n\t-o-border-radius: 6px !important;\n}\n\n.linkCssActive .plusIcon {\n\tfilter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);\n\t-webkit-filter: invert(89%) sepia(100%) saturate(27%) hue-rotate(8deg) brightness(109%) contrast(107%);\n}\n\n.confirmCodeColor {\n\tcolor: var(--common-link-color);\n}\n\n.confirmCodeColor:hover,\n.confirmCodeColor:focus,\n.confirmCodeColor:active,\n.confirmCodeColor:active:hover,\n.confirmCodeColor:focus:hover {\n\ttext-decoration: none;\n\tcolor: var(--common-link-color)\n}\n\n.detailsWidth {\n\tmin-width: 250px;\n}\n\n.wordBreak {\n\tword-break: break-word !important;\n}\n\n.noDataIconSec {\n\twidth: 114px;\n\theight: 110px;\n}\n\n.noTransactionSecSpace {\n\tmargin-top: 76px;\n\tmargin-bottom: 119px;\n}\n\n.iconTop {\n\tposition: relative;\n\ttop: -2px\n}\n\n@media screen and (max-width: 767px) {\n\t.mobileWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.listContainer {\n\t\tborder-bottom: unset;\n\t\tflex-wrap: wrap;\n\t\tflex-direction: column;\n\t}\n\n\t.listContainer li .tabItem {\n\t\tmargin-right: 0;\n\t\tmargin-left: 0;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.listFlex,\n\t.csvExport {\n\t\tmargin-right: 0;\n\t\twidth: 100%;\n\t\tmargin-bottom: 18px;\n\t\tjustify-content: center;\n\t}\n\n\t.filterBtn {\n\t\twidth: 100%;\n\t}\n\n\t.filterBtn {\n\t\tjustify-content: center;\n\t}\n\n\t.detailsWidth {\n\t\tmin-width: 230px;\n\t}\n\n\t.noTransactionSecSpace {\n\t\tmargin-top: 50px;\n\t\tmargin-bottom: 50px;\n\t}\n}\n\n@media (min-width: 992px) and (max-width: 1024px) {\n\t.searchWidth {\n\t\tmax-width: 240px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listLayout": `Transaction-listLayout-KhYFf`,
	"currencyColor": `Transaction-currencyColor-CijHM`,
	"tabItem": `Transaction-tabItem-v5RNd`,
	"active": `Transaction-active-LokEH`,
	"listContainer": `Transaction-listContainer-sb8za`,
	"marginBottom": `Transaction-marginBottom-AMM5R`,
	"marginRight": `Transaction-marginRight-S1Bqo`,
	"searchWidth": `Transaction-searchWidth-wjs9p`,
	"filterBtn": `Transaction-filterBtn-pprXr`,
	"plusIcon": `Transaction-plusIcon-C8aef`,
	"csvExport": `Transaction-csvExport-lq2sF`,
	"csvExportLink": `Transaction-csvExportLink-dyZsL`,
	"searchMarginRight": `Transaction-searchMarginRight-Vdwq7`,
	"searchBox": `Transaction-searchBox-UCAdn`,
	"searchIcon": `Transaction-searchIcon-Qeh3d`,
	"searchFlexBox": `Transaction-searchFlexBox-cGnXa`,
	"linkCssActive": `Transaction-linkCssActive-UnA4I`,
	"confirmCodeColor": `Transaction-confirmCodeColor-cSJXb`,
	"detailsWidth": `Transaction-detailsWidth-BZ1ws`,
	"wordBreak": `Transaction-wordBreak-Xf1zk`,
	"noDataIconSec": `Transaction-noDataIconSec-AH4SE`,
	"noTransactionSecSpace": `Transaction-noTransactionSecSpace-mc1BV`,
	"iconTop": `Transaction-iconTop-dMpgv`,
	"mobileWidth": `Transaction-mobileWidth-B9mTd`,
	"listFlex": `Transaction-listFlex-KXaAx`
};
module.exports = ___CSS_LOADER_EXPORT___;
